// extracted by mini-css-extract-plugin
module.exports = {"header":"TriggerCampaigns_header__2pXV2","main":"TriggerCampaigns_main__gfIOB","notificationsContainer":"TriggerCampaigns_notificationsContainer__ZnN_W"};